import axios from 'axios';

import { INTEGRATIONS_API_ENDPOINT } from 'constants/api';

const integrationsApi = axios.create({
  baseURL: INTEGRATIONS_API_ENDPOINT,
});

export default integrationsApi;
